// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat.css */
.chat-container {
    background-color: #333;
    color: white;
    padding: 20px;
    max-width: auto;
    margin: 100px;
    margin-top: 10px;
    height: 90vh;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
  
  .message-container {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px;
  }
  
  .message {
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 10px;
    max-width: 100%;
    justify-content: flex-start;
    border-radius: 10px;
    font-size: large;
    display: flex;
  }

.received-conetent {
  display: block;
}

.received-text{
  margin: 10px;
}

.received {
    color: black;
    background-color: #f2f6ff;
    height: -moz-fit-content;
    height: fit-content;
    width: -moz-fit-content;
    width: fit-content;
}

.comment-box {
  display: flex;
}

.image {
  height: 10px;
  width: auto;
}

.comment-point {
  color: white;
  background-color: #e3698c;
  height: -moz-fit-content;
  height: fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  padding: 3px;
  padding-left: 7px;
  padding-right: 7px;
}

.sent {
  background-color: #444;
  justify-content: flex-end;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  text-align: right;
  margin-left: auto;
  }

  .input-area {
    display: flex;
    margin-top: 10px;
  }
  
  .input {
    flex-grow: 1;
    border: none;
    padding: 10px;
    border-radius: 20px;
    margin-right: 10px;
  }
  
  .button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 20px;
    cursor: pointer;
  }
  
  .button:disabled {
    background-color: #ccc;
  }
  
  .button:focus,
  .input:focus {
    outline: none;
  }
  
  .loading {
    color: #aaa;
    text-align: center;
  }
`, "",{"version":3,"sources":["webpack://./src/pages/Chat.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;EACf;;AAEF;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,wBAAmB;EAAnB,mBAAmB;EACnB,2BAAsB;EAAtB,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAmB;EAAnB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB","sourcesContent":["/* Chat.css */\n.chat-container {\n    background-color: #333;\n    color: white;\n    padding: 20px;\n    max-width: auto;\n    margin: 100px;\n    margin-top: 10px;\n    height: 90vh;\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  }\n  \n  .message-container {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 10px;\n  }\n  \n  .message {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 10px;\n    max-width: 100%;\n    justify-content: flex-start;\n    border-radius: 10px;\n    font-size: large;\n    display: flex;\n  }\n\n.received-conetent {\n  display: block;\n}\n\n.received-text{\n  margin: 10px;\n}\n\n.received {\n    color: black;\n    background-color: #f2f6ff;\n    height: fit-content;\n    width: fit-content;\n}\n\n.comment-box {\n  display: flex;\n}\n\n.image {\n  height: 10px;\n  width: auto;\n}\n\n.comment-point {\n  color: white;\n  background-color: #e3698c;\n  height: fit-content;\n  min-width: fit-content;\n  width: fit-content;\n  padding: 3px;\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\n.sent {\n  background-color: #444;\n  justify-content: flex-end;\n  height: fit-content;\n  width: fit-content;\n  text-align: right;\n  margin-left: auto;\n  }\n\n  .input-area {\n    display: flex;\n    margin-top: 10px;\n  }\n  \n  .input {\n    flex-grow: 1;\n    border: none;\n    padding: 10px;\n    border-radius: 20px;\n    margin-right: 10px;\n  }\n  \n  .button {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 20px;\n    cursor: pointer;\n  }\n  \n  .button:disabled {\n    background-color: #ccc;\n  }\n  \n  .button:focus,\n  .input:focus {\n    outline: none;\n  }\n  \n  .loading {\n    color: #aaa;\n    text-align: center;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
